import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  class: "popup-box",
  style: {
    "padding": "10px 0"
  }
};
var _hoisted_2 = {
  class: "text-center"
};
var _hoisted_3 = {
  class: "mb-20"
};
var _hoisted_4 = {
  class: "has-non-empty-bookings mb-20"
};
var _hoisted_5 = {
  key: 0
};
var _hoisted_6 = {
  class: "mt-20"
};
var _hoisted_7 = {
  class: "f-bold"
};
var _hoisted_8 = {
  style: {
    "margin-top": "40px",
    "margin-bottom": "-30px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_el_col = _resolveComponent("el-col");

  var _component_el_row = _resolveComponent("el-row");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "close-btn",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.cancelLogout && _ctx.cancelLogout.apply(_ctx, arguments);
    })
  }, "x"), _createElementVNode("div", _hoisted_2, [_createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.t("nav.sign-out")), 1), _createElementVNode("div", _hoisted_4, [_ctx.hasNonEmptyBookings ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.t("common.incomplete-bookings-warning")), 1)) : _createCommentVNode("", true)]), _createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.userswitch-message")), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.t("common.confirm-signout")), 1)])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_row, {
    gutter: 20
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 12
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            class: "w-100 booking-button",
            size: "large",
            onClick: _ctx.confirmLogout
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.t("nav.sign-out")), 1)];
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 12
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            class: "w-100 booking-button",
            size: "large",
            type: "primary",
            onClick: _ctx.closeSales
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.t("nav.close-sales")), 1)];
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        _: 1
      })];
    }),
    _: 1
  })])]);
}